import React from 'react';
import './Policy.css';

export default function ReturnPolicy() {
  return (
    <div className="policy-page container">
      <h1>Return & Refund Policy</h1>
      <div className="policy-content">
        <p>Last updated: May 06, 2026</p>
        <section>
          <h2>1. Returns</h2>
          <p>We want you to be completely satisfied with your purchase. If you receive a damaged, defective, or incorrect product, you can request a return within 7 days of delivery.</p>
          <p>Since dry fruits and food items are perishable, we do not accept returns for "change of mind" or if the seal has been broken.</p>
        </section>
        <section>
          <h2>2. Refunds</h2>
          <p>Once we receive and inspect your return, we will notify you of the approval or rejection of your refund. If approved, your refund will be processed to your original method of payment within 5-7 working days.</p>
        </section>
        <section>
          <h2>3. Exchanges</h2>
          <p>We only replace items if they are defective or damaged. If you need to exchange it for the same item, send us an email at support@KOA.com.</p>
        </section>
      </div>
    </div>
  );
}
